<template>
  <div id="app">
    <!-- 头部组件 -->
    <aw-header></aw-header>
    <!-- 主要内容区域 -->
    <div class="content">
      <router-view></router-view>
    </div>
    <!-- 底部组件 -->
    <aw-footer></aw-footer>
  </div>
</template>
<script>
import AwHeader from '@/components/layout/header.vue'
import AwFooter from '@/components/layout/footer.vue'
export default {
  name: "awcloud",
  components: {
    AwHeader,
    AwFooter
  },
  data() {
    return {
      active: 1,
    };
  },
  mounted() {
      
  }
};
</script>

<style lang="less">
// 主应用容器样式
#app {
  .main-container {
    padding: 20px;
    position: relative;
    
  }
}

</style>
